<template>
	<div class="page">
		<!-- <Tip :tip="tip" /> -->
		<div class="screen_div">
			<el-button type="primary" size="small" v-permit="'/admin/role/add'" @click="open(-1)">+新增</el-button>
		</div>
		<div class="from_div">
			<el-table class="table_div" :data="roleList"
				:header-cell-style="tabStyle">
				<el-table-column prop="group_id" label="编号" width="80" align="center" />
				<el-table-column label="角色" align="center" prop="group_name" />
				<el-table-column label="操作" width="180">
					<template slot-scope="scope">
						<el-button v-if="scope.row.group_id != 1" class="item_btn" size="mini" type="primary" v-permit="'/admin/role/edit'" @click="open(scope.row.group_id)">编辑</el-button>
						<el-button v-if="scope.row.group_id != 1 && scope.row.group_id != 2" class="item_btn" size="mini" type="danger" v-permit="'/admin/role/del'" @click="del(scope.row.group_id)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		
		<!--弹出层-->
		<Popup :name="name" :show="show" @close='close' :type="group_id" />
		<div class="foot_div">
			<!--分页按钮-->
			<el-pagination class="pagination" background layout="prev, pager, next,jumper, ->, total" :total="total"
				@current-change="handleCurrentChange" :currentPage="page" :pageSize="limit">
			</el-pagination>
		</div>
	</div>
</template>

<script>
	import Tip from "../../../components/Tip/Tip.vue"
	import Popup from "../../../components/Popup/Popup.vue"
	import { roleLists, roleDel } from "../../../request/apis.js"
	import {delTip} from "../../../../src/common/store/util.js"
	export default {
		components: {
			Tip,
			Popup
		},
		data() {
			return {
				group_id: -1, //编辑需要group_id
				tip: '管理账号角色与管理功能页面配置。',
				page: 1, //当前页 刷新后默认显示第一页
				limit: 10, //每一页显示的数据量 此处每页显示10条数据
				total: 0, //总条数
				roleList: [],
				name: '',
				show: false
			}
		},
		computed: {
			tabStyle() {
				return {
					background: '#f5f5f5',
					color: '#333'
				}
			}
		},
		mounted() {
			this.getRoleList();
		},
		methods: {
			//角色列表
			getRoleList() {
				roleLists({
					page: this.page,
					limit: this.limit
				}).then(res => {
					if (res.code === 0) {
						this.total = res.count;
						this.roleList = res.data;
					}else{
                        return this.$message.error(res.msg || '请求失败');
                    }
				}).catch(err => {})
			},
			
			//删除操作
			del(group_id){
				delTip(this,'此操作将永久删除该角色, 是否继续?','提示').then(res=>{
					if(res == 0){
						roleDel({
							group_id: group_id
						}).then(res => {
							if (res.code == 0) {
								this.$message({
									type: 'success',
									message: '删除成功!'
								});
								this.page = 1;
								this.getRoleList();
							}
						}).catch(err => {})
					}
				})
			},
			
			//点击按钮切换页面
			handleCurrentChange(page) {
				this.page = page; //每次点击分页按钮，当前页发生变化
				this.getRoleList();
			},
			open(group_id) {
				this.group_id = group_id != -1 ? group_id : -1;
				this.name = 'permissionRoleEdit';
				this.show = true
			},
			close(type) {
				if (type == 0) {
					this.page = 1;
					this.getRoleList();
				}
				this.show = false
			}
		}
	}
</script>

<style scoped>
	.page {
		margin-bottom: 66px;
		padding: 20px 20px 0 20px;
		min-height: -webkit-fill-available;
	}

	.screen_div {
		display: flex;
		flex-direction: row;
		width: 100%;
		height: auto;
		margin-top: 20px;
	}

	.col {
		display: flex;
		flex-direction: column;
	}

	.el-button--mini {
		margin-right: 10px;
	}

	.item_btn {
		margin: 0 5px 0 0;
	}

	/*伪类样式*/
	.item_btn:nth-child(3) {
		margin-top: 5px;
	}
	
	.from_div {
		width: 100%;
		height: 600px;
		max-height: 100%;
		overflow: scroll;
		margin-top: 20px;
	}

	.table_div {
		width: 100%;
	}

	.foot_div {
		position: absolute;
		bottom: 0;
		left: 0;
		width: calc(100% - 120px);
		padding: 0 60px;
		margin-left: 66px;
		line-height: 66px;
		height: 66px;
		background: #fff;
		box-shadow: 0px -4px 10px -5px rgba(0, 0, 0, 0.3);
		border-radius: 0 0 10px 10px;
		z-index: 9;
	}

	.pagination {
		display: flex;
		justify-content: right;
		padding: 20px 30px 20px 30px
	}
</style>